import i18n from '~/components/i18n';
import CropImage from '@assets/svgs/klima/futterbau.jpg'
import SoilImage from '@assets/svgs/klima/Icon_Dunger_Farse.svg'
import InputsImage from '@assets/svgs/klima/Icon_Futter_Milchkuh.svg'
import EnergyImage from '@assets/svgs/klima/Icon_Energie_Milchkuh.svg'
import IrrigationImage from '@assets/svgs/klima/Icon_Molkerei.svg'
import CarbonImage from '@assets/svgs/klima/Icon_Milchkuh.svg'
import ResultsImage from '@assets/svgs/klima/Icon_Ergebnis.svg'

export enum StepId {
  CROP = 'crop',
  SOIL = 'soil',
  INPUTS = 'inputs',
  FUEL_ENERGY = 'fuel_energy',
  IRRIGATION = 'irrigation',
  CARBON = 'carbon',
  TRANSPORT = 'transport',
  RESULTS = 'results'
}

export const getCropSteps = () => [
  { title: i18n.t('Crop'), id: StepId.CROP, image: CropImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Soil'), id: StepId.SOIL, image: SoilImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Inputs'), id: StepId.INPUTS, image: InputsImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Fuel & Energy'), id: StepId.FUEL_ENERGY, image: EnergyImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Irrigation'), id: StepId.IRRIGATION, image: IrrigationImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Carbon'), id: StepId.CARBON, image: CarbonImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Transport'), id: StepId.TRANSPORT, image: IrrigationImage, style: { marginTop: 16, width: 32 } },
  { title: i18n.t('Results'), id: StepId.RESULTS, image: ResultsImage, style: { marginTop: 16, width: 32 } }
];
